var bridgeBarStates = Object.freeze({
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    RENDER: 'RENDER'
});

module.exports = bridgeBarStates;
